import { useEffect, useState } from 'react';

/**
 * Returns `value` delayed by `delay` ms, resetting the timer on each change.
 *
 * Used to collapse rapid input (search-as-you-type) into a single settled value
 * so a downstream effect fires ONE request per word instead of one per keystroke.
 * Fast typing otherwise produced a burst of concurrent, racing requests that
 * saturated the backend and let a stale response overwrite a newer one (the
 * global tree search — see useTreeState).
 */
export function useDebouncedValue(value, delay = 280) {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
}

export default useDebouncedValue;
